import { countryCodes } from "@/utils/countryCodes";

export function getISOCodeFromPhoneNumber(phoneNumber) {
  const minLength = 2;
  const maxLength = 4;

  for (let length = minLength; length <= maxLength; length++) {
    const countryCode = phoneNumber.slice(0, length);
    const isoCode = countryCodes[countryCode];

    if (typeof isoCode === "string") {
      return isoCode;
    }
  }

  return null;
}

export const parsePhoneNumber = number => {
  if (!number) {
    return {
      countryCode: null,
      areaCode: null,
      phoneNumber: null,
      isoCode: "us",
    };
  }

  if (number.startsWith("+")) {
    number = number.slice(1, number.length);
  }

  number = number.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "");

  const minCountryCodeLength = 1;
  const maxCountryCodeLength = 4;

  for (let i = maxCountryCodeLength; i >= minCountryCodeLength; i--) {
    let countryCode = number.slice(0, i);

    if (countryCode.length < i) {
      // number is not long enough to consider this length as a country code
      continue;
    }

    let isoCode = countryCodes[countryCode];

    // last char to check, if it's 1 it means the area code isn't valid
    // let's assume it's a us number
    if (i === 1 && countryCode === "1") {
      countryCode = number.slice(0, 4);
      isoCode = "US";
    }

    if (isoCode) {
      let areaCode;

      if (countryCode.startsWith("1")) {
        areaCode = countryCode.slice(1, 4);
        countryCode = "1";
      } else {
        areaCode = number.slice(i, i + 3);
      }

      return {
        countryCode,
        areaCode,
        phoneNumber: number.slice(countryCode.length + areaCode.length, number.length),
        isoCode,
      };
    }
  }

  return {
    countryCode: null,
    areaCode: null,
    phoneNumber: null,
    isoCode: "us",
  };
};

export const flatPhoneNumber = number => {
  if (!number) {
    return "";
  }

  if (typeof number === "string") {
    return number.replaceAll("-", "");
  }

  const { countryCode, areaCode, phoneNumber } = number;

  if (!phoneNumber) {
    return "";
  }

  // Format:
  // "[countryCode][space][areaCode][phoneNumber]"
  return `${countryCode || ""}${countryCode && (areaCode || phoneNumber) ? " " : ""}${areaCode || ""}${
    phoneNumber || ""
  }`;
};
